import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

const comentarios = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/comentario`,
    state: {
        ListaComentarios: []        
    }
}).get({
    action: "get_comentarios", 
    path: function (obj) {
        return `/${obj.idtabla}/${obj.idelemento}/${obj.isUserDelegate}`;
    },
    onSuccess: (state, payload) => {
        state.ListaComentarios = payload.data;
    }
}).put({
    action: "put_comentario", 
    path: function () {
        return `/guardar`;
    },      
    onSuccess: (state, payload) => {     
        state.ListaComentarios = payload.data;
        payload.data = { codigoRespuesta: 'OK', mensajeRespuesta: 'El proceso se realizó con exito', color: "successvue" }
        store.dispatch("mensaje/set_reset");
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);
    }    
}).getStore();

comentarios.getters = {
    gcomentarios: state => {
        return state.ListaComentarios
    }
}

export default comentarios;